export const quantumPageFI = {
  "seo": {
    "title": "Suvereenit LLM:t & Kvantti-tekoäly | pAIoneer Labs GmbH",
    "description": "Tavoitteemme Saksasta käsin: kehittää Veridionin ('tekoäly kehittää tekoälyä') alaisuudessa kompakteja kielimalleja ja kvanttitransformereita, jotka tulevaisuudessa kilpailevat USA:n ja Kiinan suurten mallien kanssa."
  },
  "hero": {
    "kicker": "Made in Germany · Tekoäly kehittää tekoälyä",
    "title": "Suvereenit LLM:t & Kvantti-AI",
    "claim": "Tavoitteemme Saksasta käsin: kehittää omia kielimalleja ja kvanttitransformereita, jotka tulevaisuudessa haastavat USA:n ja Kiinan suuret mallit.",
    "subtitle": "Todellisissa yritysprojekteissa nykyisiä eurooppalaisia ratkaisuja — saksalaisia Aleph Alphan malleja (kuten Kolibri), ranskalaisia Mistral-malleja, EuroLLM:ää ja erityisesti sveitsiläistä Apertus-mallia — on arvioitu aitoja käytännön ongelmia vasten. Yksikään niistä ei täytä yritysten vaatimuksia. Siksi tekoälymme ottaa [Veridion](veridion)in (”tekoäly kehittää tekoälyä”) alaisuudessa seuraavan askeleen: se tutkii ja rakentaa polkua kompakteihin Made in Germany -kielimalleihin, jotka tulevat olemaan selvästi ranskalaisia malleja suorituskykyisempiä, ja vie toisena painopisteenä eteenpäin omia kvanttitransformereita.",
    "cta": "Varaa keskustelu"
  },
  "pillars": {
    "title": "Mitä tekoälymme tutkii ja rakentaa",
    "subtitle": "Kaksi tutkimusaluetta, joissa digitaaliset asiantuntijamme suunnittelevat uusia arkkitehtuureja, testaavat niitä simulaattorissa ja rakentavat niitä vaiheittain.",
    "items": [
      {
        "title": "Mitä kielimallilta vaaditaan arjessa",
        "description": "Tuotantokäytössä ratkaisevat monivaiheinen looginen päättely, luotettava työkalujen käyttö pitkissä tehtäväketjuissa, puhdas ohjelmistokehitys ja virheettömät toimistoprosessit. Mittamme jokaisen arkkitehtuurin näitä vasten alusta alkaen."
      },
      {
        "title": "Kompaktit mallit omaan infrastruktuuriin",
        "description": "Yhä suurempien konesalien sijaan tavoitteemme tulee olemaan syvän päättelykyvyn tiivistäminen kompaktiin malliin, jota yritykset voivat ajaa paikallisesti omalla laitteistollaan."
      },
      {
        "title": "Kvanttitransformerit & Kvantti-tekoäly",
        "description": "Toisella painopistealueella tutkimme, kuinka transformer-arkkitehtuurit voidaan yhdistää parametrisoituihin kvanttipiireihin ja tensoriverkkoihin uusien malliluokkien avaamiseksi."
      },
      {
        "title": "Oma Quantum IDE & oikeat kvanttiprosessorit",
        "description": "Itse kehittämässämme Quantum IDE -ympäristössä tekoälyasiantuntijamme suunnittelevat, simuloivat ja testaavat uusia kvanttipiirejä klassisia verrokkeja vasten ennen ajoa oikealla kvanttilaitteistolla."
      }
    ]
  },
  "gate": {
    "title": "Tutkimustiedosta rakennesuunnitelmaan",
    "subtitle": "Jokainen kehitysaskel nojaa tarkastettuun kirjallisuuteen, yritysmuistiimme ja mitattaviin vertailuihin.",
    "stages": [
      {
        "step": "Vaihe 01",
        "title": "Kirjallisuusanalyysi & yritysmuisti",
        "description": "Tekoälyasiantuntijamme arvioivat jatkuvasti uusimpia kielimalli- ja kvanttiarkkitehtuurien tutkimuksia ja tallentavat vahvistetut tulokset yrityksemme tietoverkkoon."
      },
      {
        "step": "Vaihe 02",
        "title": "Koulutussuunnitelma & piirisimulaatio",
        "description": "Yhdessä tuotekehityksen kanssa tästä syntyy yksityiskohtainen koulutussuunnitelma tulevalle kielimallillemme samalla, kun uusia kvanttipiirejä kokeillaan Quantum IDE:ssä."
      },
      {
        "step": "Vaihe 03",
        "title": "Tieteellinen tarkastus IDD-prosessissa",
        "description": "Fyysikot ja tekoälytutkijat tarkastavat jokaisen hypoteesin, mittauksen ja suunnitelman [Intent-Driven Development](idd) (IDD) -menetelmällä human-in-the-loop-periaatteella ja hyväksyvät seuraavan vaiheen."
      }
    ]
  },
  "stack": {
    "title": "Ihminen ja tekoäly samassa tutkimusyksikössä",
    "subtitle": "Tutkimus, tuotekehitys ja tieteellinen valvonta nivoutuvat yhteen kiinteissä jaksoissa.",
    "items": [
      {
        "title": "Digitaaliset tutkijat ympäri vuorokauden",
        "description": "Erikoistuneet tekoälyasiantuntijat hoitavat kirjallisuuskatsaukset, matemaattiset johdot, piirisuunnittelun ja arvioinnit vuorokauden ympäri."
      },
      {
        "title": "Fyysikot Human-in-the-Loop -roolissa",
        "description": "Ihmistutkijat asettavat tutkimussuunnan, haastavat oletukset ja päättävät hyväksynnöistä, laitteistoajoista ja julkaisuista."
      },
      {
        "title": "Tiivis yhteys tuotekehitykseen",
        "description": "Yhteistyössä tuotekehityksemme kanssa kestävät tutkimustulokset siirtyvät suoraan työkaluihimme ja tuleviin yritysratkaisuihin."
      },
      {
        "title": "Jäljitettävissä alkulähteelle asti",
        "description": "Jokainen arkkitehtuuripäätös, hylätty vaihtoehto ja mittaustulos säilyy pysyvästi dokumentoituna ja tarkistettavissa."
      }
    ]
  },
  "cta": {
    "title": "Keskustelu tutkimuksesta",
    "subtitle": "Haluatko keskustella suvereeneja kielimalleja ja kvanttitransformereita koskevasta tutkimuksestamme? Kirjoita meille.",
    "button": "Lähetä viesti"
  }
};
